import c from 'classnames';
import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Size } from '../../types';
import { colors, globals } from '../../styles';
import { default as Icon, IconName } from '../icons/icon';

export interface Props {
  activeColor?: string;
  baseColor?: string;
  className?: string;
  disabled?: boolean;
  icon: IconName;
  onClick?: (e: object) => void;
  size?: Size;
  dataTest?: string;
}

export class IconButton extends React.Component<Props, any> {
  public static defaultProps: Props = {
    icon: 'info',
    size: 'md',
  };

  public render() {
    const { className, disabled, icon, onClick, size, dataTest } = this.props;

    return (
      <button
        className={c(className, size, { disabled })}
        disabled={disabled}
        onClick={onClick}
        data-test={dataTest}
      >
        <Icon baseColor="inherit" icon={icon} size={size} />
      </button>
    );
  }
}

const StyledIconButton = styled(IconButton)`
  ${globals.button};
  padding: 0; /* Override */

  display: inline-flex;
  fill: ${props => props.baseColor};

  :hover {
    fill: ${props => props.activeColor};
    transform: translateY(0);
  }

  &[disabled],
  &.disabled {
    &,
    &:hover {
      background: none; /* override */
      box-shadow: none; /* override */
      color: ${colors.grey300}; /* override */
      cursor: not-allowed; /* override */
      fill: currentcolor; /* override */
    }
  }
`;

StyledIconButton.defaultProps = {
  activeColor: colors.brand,
  baseColor: colors.grey700,
};

export default StyledIconButton;
